import { render, staticRenderFns } from "./adminTweetList.vue?vue&type=template&id=2d3ceffa&scoped=true&"
import script from "./adminTweetList.vue?vue&type=script&lang=js&"
export * from "./adminTweetList.vue?vue&type=script&lang=js&"
import style0 from "./adminTweetList.vue?vue&type=style&index=0&id=2d3ceffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ceffa",
  null
  
)

export default component.exports